import { render, staticRenderFns } from "./LinkText.vue?vue&type=template&id=f10119ba"
import script from "./LinkText.vue?vue&type=script&lang=js"
export * from "./LinkText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports